/**
 * Callback for displaying Firewall logs
 *
 * @param {obj} result
 * @param {obj} data
 * @param {obj} params
 */
function spbcTcShowMoreCallback(result, data, params) {
    if (data.full_refresh) {
        jQuery(params.wrapper).html(result);
        spbcTblRowActionsListen();
        spbcTblPaginationListen();
        spbcTblSortListen();
        spbcStartShowHide();
    } else if (result.size > 0) {
        jQuery(params.wrapper).html(result.html);
        spbcTblRowActionsListen();
        spbcStartShowHide();
    } else {
        // Hide "More logs" button, show "Control Panel" button
        jQuery(params.button).hide();
        jQuery(params.button).siblings('.spbc__show_more_logs').css('display', 'inline-block');
    }
}

/**
 * Listener for `Show more` button in the TC log
 */
function spbcTcShowMoreListen() {
    jQuery('#spbc_show_more_fw_logs_button').on('click', function() {
        if (spbcSettingsFWLogs.clicks < 2) {
            spbcSettingsFWLogs.clicks++;
            let data = {
                action: 'spbc_show_more_security_firewall_logs',
                amount: spbcSettingsFWLogs.amount * (+spbcSettingsFWLogs.clicks+1),
            };
            let params = {
                button: this,
                spinner: this.nextElementSibling,
                wrapper: jQuery('#spbc_tbl__traffic_control_logs').find('tbody'),
                callback: spbcTcShowMoreCallback,
            };
            spbcSendAJAXRequest( data, params );
        } else {
            // Hide "More logs" button, show "Control Panel" button
            jQuery(this).hide();
            jQuery(this).siblings('.spbc__show_more_logs').css('display', 'inline-block');
        }
    });
}

jQuery(document).ready(function() {
    spbcTblRowActionsListen(); // Table. Row actions handler
    spbcTblPaginationListen(); // Table. Pagination handler
    spbcTblSortListen(); // Table. Sort handler

    // Start to hide long values in a table
    spbcStartShowHide();

    // FIREWALL LOGS EVENTS

    // Handler for show more FIREWALL LOGS
    spbcTcShowMoreListen();

    // Timer for FireWall logs
    setTimeout(function spbcРeartbeat() {
        // Do refresh only if traffic control is enabled and tab is active
        if ( +spbcSettingsFWLogs.moderate && jQuery('.spbc_tab_nav-traffic_control').hasClass('spbc_tab_nav--active')) {
            let data = {
                action: 'spbc_show_more_security_firewall_logs',
                full_refresh: true,
            };
            let params = {
                wrapper: jQuery('#spbc_tbl__traffic_control_logs'),
                callback: spbcTcShowMoreCallback,
                notJson: true,
            };
            spbcSendAJAXRequest( data, params );
        }
        setTimeout(spbcРeartbeat, 60000);
    }, 60000);
});

/**
 * @param {string} ip
 * @return {boolean}
 */
function spbcTcAllowIp(ip) { // eslint-disable-line no-unused-vars
    spbcTcFilterIp( ip, 'allow');
    return false;
}

/**
 * @param {string} ip
 * @return {boolean}
 */
function spbcTcBanIp(ip) { // eslint-disable-line no-unused-vars
    spbcTcFilterIp( ip, 'deny');
    return false;
}

/**
 * @param {string} ip
 * @param {string} status 'allow'|'deny'
 * @return {boolean}
 */
function spbcTcFilterIp(ip, status) {
    const data = {
        action: 'spbc_tc__filter_ip',
        ip: ip,
        status: status,
    };
    const params = {
        callback: spbcTcAllowIpCallback,
    };
    spbcSendAJAXRequest( data, params );
    return false;
}

/**
 * @param {obj} data
 */
function spbcTcAllowIpCallback(data) {
    if (data.success) {
        alert('Success.');
    } else {
        alert(data.data);
    }
}
